import React, { ReactElement } from 'react'
import { Image, Wrapper } from '@farewill/ui'
import { BREAKPOINT } from '@farewill/ui/tokens'
import { CLOUDINARY_ROOT_PATH } from '@farewill/ui/components/Image/constants'

import FrequentlyAskedQuestions from 'components/FrequentlyAskedQuestions'
import BreakpointSwitch from 'components/BreakpointSwitch'

const FAQ = ({
  questions,
  imagePath,
}: {
  questions: GatsbyTypes.ContentfulFaqSection['questions']
  imagePath: string
}): ReactElement => (
  <Wrapper margin={0} marginFromL={['XXL', 0, 'XXL']}>
    <FrequentlyAskedQuestions
      title="Frequently asked questions"
      customImageComponent={
        <BreakpointSwitch
          breakAt={BREAKPOINT.M}
          aboveComponent={
            <Image
              path={imagePath}
              formatPath={({ path, ext, width }) =>
                `${CLOUDINARY_ROOT_PATH}/c_fill,f_auto,q_auto,h_${width},w_${width}/r_max/${path}.${ext}`
              }
              ext="jpg"
              width={350}
            />
          }
        />
      }
      questions={questions}
      customAmount={4}
    />
  </Wrapper>
)

export default FAQ
